import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";
import CaptchaField from "@/components/CaptchaField";

export default function VolunteerDialog({ need, onClose, onDone }) {
  const [form, setForm] = useState({ name: "", contact: "" });
  const [captcha, setCaptcha] = useState({ a: 0, b: 0, answer: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (need) setForm({ name: "", contact: "" });
  }, [need]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.contact.trim()) {
      toast.error("Por favor complete su nombre y contacto");
      return;
    }
    if (captcha.answer === "" || captcha.answer === null) {
      toast.error("Por favor responda la verificación");
      return;
    }
    setLoading(true);
    try {
      await api.post(`/needs/${need.id}/volunteer`, { ...form, captcha });
      toast.success("¡Gracias por ofrecerse a ayudar! Dios le bendiga.");
      onDone && onDone();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al ofrecer ayuda");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!need} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="volunteer-dialog"
        className="max-w-lg bg-white border-2 border-[#D1C9C1]"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#1A1818]">
            Yo Puedo Ayudar
          </DialogTitle>
          <DialogDescription className="text-base text-[#4A4646]">
            {need?.title}
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="vname" className="text-base font-semibold text-[#1A1818] mb-1.5 block">
              Su Nombre <span className="text-[#8A3A33]">*</span>
            </Label>
            <Input
              id="vname" data-testid="volunteer-name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="h-12 text-base border-2 border-[#D1C9C1]"
            />
          </div>
          <div>
            <Label htmlFor="vcontact" className="text-base font-semibold text-[#1A1818] mb-1.5 block">
              Teléfono o Correo electrónico <span className="text-[#8A3A33]">*</span>
            </Label>
            <Input
              id="vcontact" data-testid="volunteer-contact"
              value={form.contact}
              onChange={(e) => setForm({ ...form, contact: e.target.value })}
              placeholder="Para que puedan contactarle"
              className="h-12 text-base border-2 border-[#D1C9C1]"
            />
          </div>

          <CaptchaField value={captcha} onChange={setCaptcha} />

          <DialogFooter className="gap-3">
            <Button
              type="button" variant="outline" onClick={onClose}
              className="h-12 px-6 text-base border-2 border-[#D1C9C1]"
            >
              Cancelar
            </Button>
            <Button
              type="submit" disabled={loading}
              data-testid="volunteer-submit"
              className="h-12 px-6 text-base font-semibold bg-[#2C5545] hover:bg-[#1F3D32] text-white"
            >
              {loading ? "Enviando..." : "Ofrecerme a Ayudar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
